export const experiences = [
  {
    role: 'Full-Stack Engineer & Data Analyst',
    company: 'Aquality Halmstad',
    companyUrl: 'https://aqualityhalmstad.se/',
    duration: 'July 2026 - Present',
    responsibilities: [
      'Transforming raw data into meaningful insights through visualization and interpretation.',
      'Designing and developing software solutions across both frontend and backend systems.'
    ]
  },
  {
    role: 'Software Engineer',
    company: 'CampusLyan',
    companyUrl: 'https://www.campuslyan.se/',
    duration: 'February 2026 - Present',
    responsibilities: [
      'Working on the website design and layout'
    ]
  },
  {
    role: 'Volunteer',
    company: '10billion.org',
    companyUrl: 'https://10billion.org/', // Add the organization's website
    duration: 'August 2024 – Present',
    responsibilities: [
      'Managing the frontend team and project',
      'Writing content for the website',
      'Working on the website design and layout']
  },
  {
    role: 'Senior Software Engineer',
    company: 'Hubar Tech Ltd',
    companyUrl: 'https://hubartech.com/', // Add the organization's website
    duration: 'November 2022 - July 2025',
    responsibilities: [
      'Leading and managing a team of 5 while implementing client-driven features.',
      'Collaborating with team members and clients across different countries.',
      'Analyzing and integrating third-party TMForum APIs according to international telecom industry standards.',
      'Actively involved in coding and maintaining a nx monorepo with 7 frontend projects, continuously scaling it by creating custom libraries to enhance code reusability.',
      'Developing a mobile application for Telecom Self-Service Application.'
    ]
  },
  {
    role: 'Software Engineer',
    company: 'Aubichol Intelligent Technologies',
    companyUrl: 'https://aubichol.com/', // Add the organization's website
    duration: 'July 2018 - November 2022',
    responsibilities: [
      'Contributed to 6 projects (Aubichol, Khelahobe!, Suit and Sarto, Gaachwala, Love Beyond Autism, Skinfinity), mostly developing frontend projects from scratch.',
      'Integrated RESTful APIs, wrote clean and reusable code, and maintained the sites for over 4 years while creating pixel-perfect UIs with intuitive layouts.',
      'Collaborated with backend teams to understand and implement requirements.'
    ]
  },
  
];
